import PropTypes from 'prop-types';
import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useIntl } from 'react-intl';

import FlashesRenderer from 'src/components/Flashes/FlashesRenderer';
import Loading from 'src/components/Loading';
import AnonymousNavigation from 'src/components/Navigation/AnonymousNavigation';
import Footer from 'src/enosikit/components/Footer';

/**
 * Description
 * @param {object} props
 * @param {React.ReactNode} props.children
 * @returns {React.ReactComponentElement} - AnonymousLayout component
 */
function AnonymousLayout({ children = <Loading /> }) {
  const intl = useIntl();

  const pageTitle = intl.formatMessage({ id: 'layout.anonymous_layout.page.title', defaultMessage: 'Enosi - Login to get started' });

  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>{pageTitle}</title>
      </Helmet>

      <div className="flex flex-column" style={{ minHeight: '80vh' }}>
        <AnonymousNavigation />
        <FlashesRenderer />
        <div className="flex-auto">{children}</div>
      </div>

      <Footer versionUI={VERSION} />
    </>
  );
}

AnonymousLayout.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
};

export default AnonymousLayout;
